export default __webpack_public_path__ + "static/media/instagram-square-brands.41aaeb27.svg";